import { Flex, Text } from "@unifize/sarah";

const InfoBanner = () => {
  return (
    <Flex
      items="flex-start"
      gap="0.75rem"
      background="#EFF6FF"
      style={{
        border: "1px solid #BFDBFE",
        borderRadius: "0.5rem",
        padding: "1rem 1rem 1rem 1.25rem",
        marginBottom: "2rem",
        maxWidth: "42rem",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      <Text variant="body" weight="regular" color="#667085">
        Thank you for choosing Unifize through Azure Marketplace. Complete the
        onboarding process below to activate your subscription and access your
        workspace.
      </Text>
    </Flex>
  );
};

export default InfoBanner;
